import { EmptystateArrowsLeftRightBothColored } from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import EmptyState from "ds/components/EmptyState";
import TileWrapper from "ds/components/Tile/Wrapper";

const DashboardResourcesChartEmptyNoDrift = () => {
  return (
    <TileWrapper padding="x-large" fullWidth justify="center">
      <EmptyState
        title="Drift Detection not enabled"
        icon={EmptystateArrowsLeftRightBothColored}
        caption="Enable Drift Detection on your stacks to be able to preview your resources health."
      >
        <Box gap="medium">
          {/* TODO: [dashboard] userflow trigger */}
          <Button variant="primary">Show me how</Button>
        </Box>
      </EmptyState>
    </TileWrapper>
  );
};

export default DashboardResourcesChartEmptyNoDrift;
